export function capitalize(str: string) {
  if (!str) {
    return str;
  }
  return str.replace(str[0], str[0].toUpperCase());
}
